import React from "react";
import { platform } from "@/content/site";
import { PageHero, Section, CtaBand } from "@/components/NovaKit";

export default function Platform() {
  return (
    <div data-testid="platform-page">
      <PageHero eyebrow={platform.eyebrow} heading={platform.heading} highlight="not a disconnected toolset" intro={platform.intro} index="06" />

      <Section eyebrow="Four-stage operating flow" heading="Setup → Office → Connect → Intelligence" highlight="Setup → Office → Connect → Intelligence" indexLabel="06.1" bg="panel">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {platform.stages.map(([title, body], i) => (
            <div key={title} className="grad-border grad-border-on card-hover bg-white rounded-[20px] p-8 md:p-10 relative overflow-hidden" data-testid={`platform-stage-${i}`}>
              <div className="absolute -top-8 -right-4 display text-[8rem] font-black grad-text opacity-10 leading-none">0{i + 1}</div>
              <div className="flex items-baseline gap-3 mb-5 relative">
                <span className="mono text-[11px] tracking-[0.22em] uppercase font-bold grad-text">STAGE · 0{i + 1}</span>
              </div>
              <h3 className="display text-2xl md:text-3xl font-bold mb-4 leading-tight relative">{title}</h3>
              <p className="text-sm md:text-base leading-relaxed text-[#0A0E1A]/75 relative">{body}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section eyebrow={platform.whyHeading} heading="From fragmented execution to decision-ready operations" highlight="decision-ready operations" indexLabel="06.2" bg="panel">
        <p className="text-base md:text-xl leading-[1.6] text-[#0A0E1A]/80 max-w-4xl border-l-4 border-[#4F46E5] pl-6">
          {platform.whyBody}
        </p>
      </Section>

      <CtaBand heading="See how the coordination layer fits your model." ctas={platform.ctas} />
    </div>
  );
}
